var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal-gcc",attrs:{"hide-footer":"","id":"modal-gcc","size":"lg","title":"รายละเอียด"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('GccDetail',{attrs:{"gccObj":_vm.gccObj}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }